import React from 'react';

function promociones() {
    return (
    <p>hola papu promociones</p>
    );
  }
  
export default promociones;
  